import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import GearButton from "../ui/gearbutton";

const LanguageSelector: React.FC = () => {
  const { i18n } = useTranslation();

  // Logga la lingua all'avvio del componente
  useEffect(() => {
    console.log(`Lingua corrente all'avvio: ${i18n.language}`);
  }, []);

  const changeLanguage = (language: string) => {
    console.log(`Cambiando lingua in: ${language}`);
    i18n.changeLanguage(language);
    console.log(`Lingua corrente dopo il cambio: ${i18n.language}`);

    // Salva la preferenza della lingua nel localStorage per mantenerla tra le sessioni
    localStorage.setItem("i18nextLng", language);
  };

  return (
    <div className="flex items-center space-x-2">
      <GearButton
        variant="primary"
        size="small"
        className="rounded-[8px]"
        onClick={() =>
          i18n.language === "it" ? changeLanguage("en") : changeLanguage("it")
        }
      >
        <img
          src={"/icons/world.svg"}
          alt="World"
          className="h-4 object-contain"
        />
        {i18n.language === "it" || i18n.language.startsWith("it")
          ? "ITA"
          : "ENG"}
      </GearButton>
    </div>
  );
};

export default LanguageSelector;
